import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { IonPage } from '@ionic/react';

import Header from '../header/Header';
import ABMUsers from './ABMUsers';
import ABMConsulta from './ABMConsulta';

import './ABMUsers.css';

interface Props extends StateTypes, dispatchTypes { }

const ABMUsersMainPage: React.FC<Props> = (props): JSX.Element => {

    const [clientSelected, setClientSelected] = useState('');

    useEffect(() => {
        setClientSelected(sessionStorage.getItem('clientUsers') ?? '')
    }, [sessionStorage.getItem('clientUsers')]);


    return (
        <IonPage>
            <Header headerText='ABM Usuarios' />

            {
                clientSelected === 'CONSULTA'?
                    <ABMConsulta/>
                :
                <ABMUsers/>
            }

        </IonPage>
    );
}

interface StateTypes {
}

const mapStateProps = (state: StateTypes) => {
    return {
    }
}

interface dispatchTypes {
}

const mapDispatchToProps = (dispatch: any) => {
    return {
    };
}

export default connect(mapStateProps, mapDispatchToProps)(ABMUsersMainPage);